import vivo from '@images/vivo.png';
import trocafone from '@images/trocafone-logo.png';

const domEle = document.createElement('div');
const checkList = (conditions) => {
  const mapCondition = { Y: 'Sim', N: 'Não', NA: 'Não se aplica' };
  return `
    <div class="row mx-1 my-n1">
      ${conditions.map(
    ({ question, condition }) => `
          <div class="col-auto col-sm-3">
            <p style="font-weight: 600">${question}</p>
          </div>
          <div class="col-auto col-sm-3">${mapCondition[condition]}</div>
        `,
  )}
    </div>`;
};
const shtml = (value) => {
  domEle.innerText = value ?? '';
  return domEle.innerHTML;
};

const getPageHtml = (customer, order, pageName) => {
  const { billing, delivery } = customer;
  return `<div class="container pt-3">
	<div class="row">
		<div class="col-12 text-center">
			<h4>Ordem de Serviço</h4>
		</div>
	</div>
	<div class="row justify-content-between text-center">
		<div class="col-4" style="text-align:left">
			<img src="${shtml(vivo)}" height="35rem" width="auto">
		</div>
		<div class="col-4" style="display:grid; place-items: center;">
			<!--?xml version="1.0" standalone="no" ?-->
			
      <div style="font-family: 'Libre Barcode 128';font-size: 65px;" class="mb-n4">
        ${shtml(order?.id)}
      </div>
			<label>${shtml(order?.id)}</label>
		</div>
		<div class="col-4">
			<!-- <h2>Trocafone Reparo</h2> -->
			<div class="align-items-center d-flex flex-column text-center">
				<img src="${shtml(trocafone)}" height="35rem">
				<label class="logoLabel">Reparo</label>
			</div>
		</div>
	</div>
	<hr>
	<h4>Dados do cliente</h4>
	<fieldset id="customer_data" class="customer_data mb-2">
		<div class="row mx-1 my-n1">
			<div class="col-auto col-sm-1">
				<p style="font-weight: 600">Nome:</p>
			</div>
			<div class="col-auto col-sm-4">
        ${shtml(customer?.name)}
			</div>
			<div class="col-auto col-sm-1">
				<p style="font-weight: 600">Email:</p>
			</div>
			<div class="col-auto col-sm-3">
				${shtml(customer?.email)}
      </div>
			<div class="col-auto col-sm-1">
				<p style="font-weight: 600">Celular:</p>
			</div>
			<div class="col-auto col-sm-2">
        ${shtml(customer?.phone)}
      </div>
		</div>

		<div class="row mx-1 my-n1">

	</div></fieldset>
	<fieldset>
		<h5>Endereço de cobrança</h5>
		<div class="row mx-1 my-n1">
			<div class="col-auto col-sm-1">
				<p style="font-weight: 600">CEP:</p>
			</div>
			<div class="col-auto col-sm-2">
				${shtml(billing?.zipCode)}
      </div>
			<div class="col-auto col-sm-1">
				<p style="font-weight: 600">Estado:</p>
			</div>
			<div class="col-auto col-sm-3">
        ${shtml(billing?.state)}
      </div>
			<div class="col-auto col-sm-1">
				<p style="font-weight: 600">Cidade:</p>
			</div>
			<div class="col-auto col-sm-2">
        ${shtml(billing?.city)}
      </div>
		</div>
		<div class="row mx-1 my-n1">
			<div class="col-auto col-sm-1">
				<p style="font-weight: 600">Bairro:</p>
			</div>
			<div class="col-auto col-sm-2">
        ${shtml(billing?.neighborhood)}
			</div>
			<div class="col-auto col-sm-1">
				<p style="font-weight: 600">Rua:</p>
			</div>
			<div class="col-auto col-sm-5">
        ${shtml(billing?.street)}
      </div>
		</div>
		<div class="row mx-1 my-n1">

			<div class="col-auto col-sm-1">
				<p style="font-weight: 600">Número:</p>
			</div>
			<div class="col-auto col-sm-2">
				${shtml(billing?.number)}
      </div>
			<div class="col-auto col-sm-1">
				<p style="font-weight: 600">Compl.:</p>
			</div>
			<div class="col-auto">
        ${shtml(billing?.complement)}
			</div>
		</div>
	</fieldset>
	<fieldset>
		<h5>Endereço de entrega</h5>
		<div class="row mx-1 my-n1">
			<div class="col-auto col-sm-1">
				<p style="font-weight: 600">CEP:</p>
			</div>
			<div class="col-auto col-sm-2">
				${shtml(delivery?.zipCode)}
      </div>
			<div class="col-auto col-sm-1">
				<p style="font-weight: 600">Estado:</p>
			</div>
			<div class="col-auto col-sm-3">
        ${shtml(delivery?.state)}
      </div>
			<div class="col-auto col-sm-1">
				<p style="font-weight: 600">Cidade:</p>
			</div>
			<div class="col-auto col-sm-2">
        ${shtml(delivery?.city)}
      </div>
		</div>
		<div class="row mx-1 my-n1">
			<div class="col-auto col-sm-1">
				<p style="font-weight: 600">Bairro:</p>
			</div>
			<div class="col-auto col-sm-2">
        ${shtml(delivery?.neighborhood)}
			</div>
			<div class="col-auto col-sm-1">
				<p style="font-weight: 600">Rua:</p>
			</div>
			<div class="col-auto col-sm-5">
        ${shtml(delivery?.street)}
      </div>
		</div>
		<div class="row mx-1 my-n1">

			<div class="col-auto col-sm-1">
				<p style="font-weight: 600">Número:</p>
			</div>
			<div class="col-auto col-sm-2">
				${shtml(delivery?.number)}
      </div>
			<div class="col-auto col-sm-1">
				<p style="font-weight: 600">Compl.:</p>
			</div>
			<div class="col-auto">
        ${shtml(delivery?.complement)}
			</div>
		</div>
	</fieldset>
	<hr>
	<h4>Dados da ordem</h4>
	<fieldset id="order_data" class="py-2 order_data mb-2">
		<div class="row mx-1 my-n1">
			<div class="col-auto col-sm-3">
				<p style="font-weight: 600">Número da ordem:</p>
			</div>
			<div class="col-auto col-sm-3">
        ${shtml(order?.id)}
      </div>
			<div class="col-auto col-sm-2">
				<p style="font-weight: 600">Data de criação:</p>
			</div>
			<div class="col-auto">
        ${shtml(order?.createdAt || new Date().toLocaleDateString())}
      </div>
		</div>
		<div class="row mx-1 my-n1">
			<div class="col-auto col-sm-3">
				<p style="font-weight: 600">Defeitos informados:</p>
			</div>
			<div class="col-auto col-sm-3">
        ${shtml(JSON.parse(order?.defects).join(', '))}
      </div>
			<div class="col-auto col-sm-2">
				<p style="font-weight: 600">Imei informado:</p>
			</div>
			<div class="col-auto d-flex">
        ${shtml(order?.imei ?? 'Não informado')}
      </div>
		</div>
		<div class="row mx-1 my-n1">
			<div class="col-auto col-sm-3">
				<p style="font-weight: 600">Produto informado:</p>
			</div>
			<div class="col-auto col-sm-3">
        ${shtml(order?.product.name)}
      </div>
			<div class="col-sm-2">
				<p style="font-weight: 600">Valor do reparo:</p>
			</div>
			<div class="col-auto">
        R$ ${shtml(order?.budget / 100)}
      </div>
		</div>
		<div class="row mx-1 my-n1">
			<div class="col-auto col-sm-3">
				<p style="font-weight: 600">Observações do aparelho:</p>
			</div>
			<div class="col-auto col-sm-3">
        ${shtml(order?.commentDefects)}
			</div>
			<div class="col-auto col-sm-2">
				<p style="font-weight: 600">Autorizada:</p>
			</div>
			<div class="col-auto">
				Vivo
      </div>
		</div>
		${checkList(order.conditions)}
		<div class="row mx-1 my-n1">
			<div class="col-auto col-sm-3">
				<p style="font-weight: 600">Prazo de Reparo:</p>
			</div>
			<div class="col-auto col-sm-3">3 dias úteis</div>
		</div>
		<div class="row mx-1 my-n1">
			<div class="col-auto col-sm-3">
				<p style="font-weight: 600">Termos de serviço:</p>
			</div>
			<div class="col-auto">
			Este documento contém as condições e regulamentos aos quais o Cliente se submetem quando da contratação dos serviços de reparo, prestados por TROCAFONE – COMERCIALIZAÇÃO DE APARELHOS ELETRÔNICOS LTDA.
1. Como funciona? O Cliente interessado deverá procurar uma das lojas Vivo participantes, relatando o defeito apresentado no Aparelho ao Vendedor. Este, por sua vez, confirmando a existência do defeito, gerará um orçamento prévio que, caso aprovado pelo Cliente, deverá ser pago, por meio de cartão de crédito, no ato da emissão da Ordem de Serviço. 2. Da coleta A TROCAFONE, então, realiza a coleta do Aparelho, na loja Vivo participante, encaminhando-o ao centro de reparo para a prestação do serviço e, posteriormente, entrega na loja ou em outro endereço, conforme opção do Cliente na Ordem de Serviço, bem como de acordo com a abrangência da TROCAFONE. 3. Da Garantia  A TROCAFONE oferece garantia de 90 (noventa) dias, especificamente, sobre o reparo realizado, devendo ser apresentada a nota fiscal do serviço para aplicabilidade. A TROCAFONE não poderá ser responsabilizada por reparos de outras peças ou defeitos pré-existentes, além do que efetivamente foram contratados. 4. Do pagamento O Pagamento é realizado pelo Cliente quando da emissão da Ordem de Serviço pela Loja Participante. Caso não seja possível realizar o reparo solicitado, a TROCAFONE realizará o procedimento de estorno do pagamento, conforme condições da operadora do cartão. Nesse caso, o estorno será realizado de forma integral, sendo o Aparelho devolvido sem custos para o Cliente. 5. Privacidade dos Dados A TROCAFONE declara que cumpre todas as formalidades necessárias para manter em sigilo eventuais dados pessoais contidos em seu Aparelho e que os dados pessoais do Cliente, coletados quando da solicitação dos serviços, serão armazenados, exclusivamente, para histórico da operação.  Em alguns reparos, há riscos de perder toda a informação contida no aparelho, portanto, é recomendado fazer um backup na nuvem dos arquivos principais antes do seu envio.  6. Condições Gerais O Cliente se declara ciente de que alguns tipos de reparo possuem risco de danificar permanentemente o aparelho. Nessa hipótese, caso o Cliente decida seguir com o reparo, ele se declara ciente de que a TROCAFONE não poderá ser responsabilizada em caso de dano permanente no aparelho. 
Não é necessário desbloquear o aparelho, entretanto dependendo da peça a ser reparada, será necessário a senha de tela para o teste. O Cliente se declara ciente e de acordo de que, caso necessário, fornecerá a senha para desbloqueio do Aparelho.
			</div>
		</div>
	</fieldset>
	<div class="row justify-content-between text-center mt-5">
		<div class="col-4">
			<hr>
			<label>${customer.name}</label>
		</div>
		<div class="col-4">
			<hr>
			<label>VIVO</label>
		</div>
	</div>
	<div class="row justify-content-center text-center">
		<div class="col">
		<label>${pageName}</label>
		</div>
	</div>
</div>
<p style="page-break-after: always;">&nbsp;</p>`;
};
export default function getPrintView(customer, order) {
  const pages = ['Vivo', 'Cliente', 'Trocafone'].map((page) => getPageHtml(customer, order, page));
  return `
<html><head>

	<link rel="preconnect" href="https://fonts.gstatic.com">
	<link href="https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600;700&amp;display=swap" rel="stylesheet">

	<link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap@4.6.0/dist/css/bootstrap.min.css" integrity="sha384-B0vP5xmATw1+K9KRQjQERJvTumQW0nPEzvF6L/Z6nronJ3oUOFUFpCjEUQouq2+l" crossorigin="anonymous">
	<script src="https://cdnjs.cloudflare.com/ajax/libs/popper.js/1.14.3/umd/popper.min.js" integrity="sha384-ZMP7rVo3mIykV+2+9J3UJ46jBk0WLaUAdn689aCwoqbBJiSnjAK/l8WvCWPIPm49" crossorigin="anonymous"></script>
	<script src="https://code.jquery.com/jquery-3.5.1.slim.min.js" integrity="sha384-DfXdz2htPH0lsSSs5nCTpuj/zy4C+OGpamoFVy38MVBnE+IbbVYUew+OrCXaRkfj" crossorigin="anonymous"></script>
	<script src="https://cdn.jsdelivr.net/npm/bootstrap@4.6.0/dist/js/bootstrap.bundle.min.js" integrity="sha384-Piv4xVNRyMGpqkS2by6br4gNJ7DXjqk09RmUpJ8jgGtD7zP9yug3goQfGII0yAns" crossorigin="anonymous"></script>
  <link href='https://fonts.googleapis.com/css?family=Libre+Barcode+128' rel='stylesheet'>
	<style>		
		@media only screen {
			html {
				overflow: auto;
			}
			body{
				height: 100%;
				overflow: scroll;
			}
		}
    body {
      height: 100%;
    }
		.logoLabel {
			color: #808083;
			font-size: 1.5rem;
			font-weight: 500;
			font-family: 'Poppins';
		}
	</style>
</head>
<body>${pages}</body>
<script type="text/javascript">
	const waitUntilImageIsLoaded = () => {
		return new Promise((resolve) => {
			let imagesLoaded = false;
			setInterval(() => {
				imagesLoaded = !Array.from($('img')).map(img => img.complete).includes(false);
				if(imagesLoaded)
					resolve(imagesLoaded);
			},500);
		})
	}
	waitUntilImageIsLoaded().then(() => {
		window.print();
	});
</script>
</html>`;
}
